"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));
var _alloyReactButton = require("@adsk/alloy-react-button");
var _alloyProvider = require("@adsk/alloy-provider");
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _nirvanaFolderPicker = _interopRequireDefault(require("@adsk/nirvana-folder-picker"));
var _es = require("@adsk/docs-js-sdk/es");
var _i18n = require("../../../i18n");
var _getDocsEnv = _interopRequireDefault(require("../helpers/getDocsEnv"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FolderSelector = _ref => {
  let {
    className,
    disabled,
    onChange,
    projectId,
    folderUrn
  } = _ref;
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [folderTitle, setFolderTitle] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(false);
  const productId = (0, _alloyProvider.useCurrentProductId)();
  const {
    T
  } = (0, _i18n.useTranslation)();
  (0, _react.useEffect)(() => {
    _es.Docs.init({
      region: (0, _acsScWebPlatformApi.getRegion)(),
      env: (0, _getDocsEnv.default)(),
      getToken: _acsScWebPlatformApi.getCurrentToken
    });
    if (folderUrn && !folderTitle && !disabled) {
      setIsLoading(true);
      _es.Docs.Folders.getFolder(projectId, folderUrn).then(folder => {
        setFolderTitle(folder.title);
        setIsLoading(false);
        setError(folder.deleted || folder.hidden);
      }).catch(err => err);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(StyledContainer, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    disabled: disabled,
    onClick: () => setShowModal(true),
    $hasPlaceholder: !folderTitle,
    $disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(StyledButtonLabel, {
    $hasError: error
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, T.translate('folderSelector.loadingText'), /*#__PURE__*/_react.default.createElement(_alloyReactProgressRing.default, {
    size: _alloyReactProgressRing.default.SIZES.XSMALL
  })) : /*#__PURE__*/_react.default.createElement(StyledButtonSpan, null, folderTitle || T.translate('folderSelector.placeholder'))), /*#__PURE__*/_react.default.createElement(StyledButtonAction, {
    $disabled: disabled
  }, T.translate('folderSelector.button.open'))), /*#__PURE__*/_react.default.createElement(_nirvanaFolderPicker.default, {
    productId: productId,
    toolId: _nirvanaFolderPicker.default.TOOL_IDS.REPORTS,
    defaultLoadFolderKey: error ? undefined : folderUrn,
    projectId: projectId,
    multiple: false,
    footerTipRenderer: () => null,
    show: showModal,
    onCancel: () => setShowModal(false),
    onSelect: _ref2 => {
      let {
        folders
      } = _ref2;
      const {
        title,
        urn,
        deleted,
        hidden
      } = folders[0];
      setFolderTitle(title);
      setShowModal(false);
      setError(deleted || hidden);
      onChange({
        folderUrn: urn
      });
    },
    fullPath: true,
    title: T.translate('folderSelector.title'),
    cancelButtonLabel: T.translate('folderSelector.button.cancel'),
    confirmButtonLabel: T.translate('folderSelector.button.save'),
    includePermission: true,
    nodeValidator: _ref3 => {
      let {
        permissionActions = []
      } = _ref3;
      if (!permissionActions.includes('publish')) {
        return {
          message: T.translate('folderSelector.noPublishPermission')
        };
      }
    }
  }), error && /*#__PURE__*/_react.default.createElement(ErrorMessage, null));
};
const ErrorMessage = () => {
  const {
    T
  } = (0, _i18n.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(StyledErrorContainer, null, /*#__PURE__*/_react.default.createElement(StyledAlertWarningFilledIcon, {
    size: 16
  }), /*#__PURE__*/_react.default.createElement(StyledErrorMessage, null, T.translate('folderSelector.notFound')));
};
const StyledContainer = _styledComponents.default.div`
  flex-shrink: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
const StyledButton = (0, _styledComponents.default)(_alloyReactButton.BasicButton)`
  flex-shrink: 0;
  flex-grow: 1;
  display: flex;
  height: 36px;
  padding: 0px;
  justify-content: space-between;
  &:focus-within {
    box-shadow: rgba(6, 150, 215, 0.35) 0px 0px 0px 2px;
  }
  color: ${_ref4 => {
  let {
    $hasPlaceholder
  } = _ref4;
  return $hasPlaceholder ? '#999999' : '#3c3c3c';
}};
  ${_ref5 => {
  let {
    $disabled
  } = _ref5;
  return `
    ${$disabled && 'background: #f6f6f6;'}
  `;
}}
`;
const StyledButtonLabel = _styledComponents.default.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 6px 12px;
  overflow: hidden;
  height: 36px;
  border: 1px solid;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
  ${_ref6 => {
  let {
    $hasError
  } = _ref6;
  return `
    border-color: ${$hasError ? _alloyReactTheme.default.colors.red500 : '#dcdcdc'};
  `;
}}
`;
const StyledButtonSpan = _styledComponents.default.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const StyledButtonAction = _styledComponents.default.div`
  flex-shrink: 0;
  width: 117px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  height: 36px;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  border-right: 1px solid #dcdcdc;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
  ${_ref7 => {
  let {
    $disabled
  } = _ref7;
  return `
    color: ${$disabled ? '#999999' : '#3c3c3c'};
  `;
}}
`;
const StyledErrorContainer = _styledComponents.default.div`
  display: flex;
  margin: 4px 0;
`;
const StyledAlertWarningFilledIcon = (0, _styledComponents.default)(_alloyReactIcon.AlertWarningFilledIcon)`
  flex-shrink: 0;
  margin-top: 2px;
  color: ${_alloyReactTheme.default.colors.red500};
`;
const StyledErrorMessage = _styledComponents.default.span`
  font-size: 12px;
  color: ${_alloyReactTheme.default.colors.red700};
  margin-left: 8px;
`;
FolderSelector.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  projectId: _propTypes.default.string.isRequired,
  folderUrn: _propTypes.default.string
};
var _default = exports.default = FolderSelector;